import AEMWrapper from "aem/ComponentWrapper";
import meta from "./aem-meta";
import loadable from "@loadable/component";
import React from "react";

const Component = loadable(
  () =>
    import(
      /* webpackChunkName: "component-intl-email-subscription-form" */ "./"
    ),
  {
    fallback: <></>
  }
);

export default AEMWrapper(meta, Component);
